import vmClient from 'app/services/vmClient';
import pick from 'lodash/pick';
import { Entity, IEntity, IEntityType } from '../../types/entity';
import {
  ITeacher,
  teacherAttributes,
  teacherAssociations,
} from './Teacher';

export interface ILessonTeacher extends IEntity {
  attributes: Pick<
    ITeacher['attributes'],
    'id' | 'name' | 'gender' | 'nationality' | 'skypeId' | 'languageProficiencies' | 'teachingSkills'
  >;
  associations: Pick<ITeacher['associations'], 'profileImage'>;
}

export type LessonTeacher = Entity<ILessonTeacher>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonTeacher: IEntityType<ILessonTeacher> = vmClient.defineClass({
  typeName: 'LessonTeacher',
  version: 1,
  persisted: true,

  attributes: pick(
    teacherAttributes,
    ['name', 'gender', 'nationality', 'skypeId', 'languageProficiencies', 'teachingSkills'],
  ),

  associations: pick(teacherAssociations, ['profileImage']),
});
